var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "newPopover",
    {
      ref: "newPopover",
      attrs: { title: _vm.form.id ? "修改游戏" : "新增游戏" },
      on: {
        dlodingHide: function($event) {
          return _vm.clearData("")
        },
        clearData: function($event) {
          return _vm.clearData(_vm.form.id)
        },
        submitData: _vm.submitData
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "语言", prop: "language" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.language,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "language", $$v)
                        },
                        expression: "form.language"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "中文", value: "zh" }
                      }),
                      _c("el-option", { attrs: { label: "英语", value: "en" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入标题" },
                    model: {
                      value: _vm.form.title,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "年份", prop: "title" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyy",
                      type: "year",
                      placeholder: "选择年"
                    },
                    model: {
                      value: _vm.form.year,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "year", $$v)
                      },
                      expression: "form.year"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v("启用")
                      ]),
                      _c("el-radio", { attrs: { label: 2, border: "" } }, [
                        _vm._v("禁用")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "内容", prop: "content" }
                },
                [
                  _c("Editor", {
                    model: {
                      value: _vm.form.content,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }